import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";
import { Icon } from "@iconify-icon/solid";
import { cn } from "@/libs/cn";

export function FileInput(props) {

  const onInput = (ev) => {
    props?.input(props.name, ev.target.value);
  }

  const onKeyUp = (ev) => {
    if (props.keyaction) {
      props?.keyaction(ev);
    }
  }

  const onKeyDown = (ev) => {
    if (props.submitOnEnter && ev.key === 'Enter') {
      props?.submit();
    }
  }

  return (
    <TextFieldRoot name={props.name} class={cn("space-y-0", props.class)}>
      <TextFieldLabel class={props.sr ? 'sr-only mb-0' : ''}>{props.label}</TextFieldLabel>
      <div class="relative">
        <TextField
          class={cn("mt-[0px]", props.inputClass)}
          placeholder={props.placeholder ?? ''}
          type={'file'}
          autoCapitalize="none"
          autocorrect="off"
          disabled={props.loading || props.disabled}
          value={props.form[props.name]}
          onChange={onInput}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          readOnly={props.readOnly}
          max={props.max}
          min={props.min}
        />
        <Show when={props.icon ?? false}>
          <Icon icon={props.icon} width="21" height="21" onClick={props.iconOnClick ?? {}} class="absolute right-3 cursor-pointer top-1/2 transform -translate-y-1/2" />
        </Show>
      </div>
    </TextFieldRoot>
  );
}
